// Submitted build60 HomeScreen memberCandidates and activityLabel rules.
export function homeMemberReason(member) {
  const reason = {
    SIMILAR_TASTE: 'similarTaste',
    ACTIVE_REVIEWER: 'active',
    RISING_REVIEWER: 'rising',
    DISCOVERY_MIX: 'discovery',
  }[member.recommendationReason];
  return typeof reason === 'string' ? reason : undefined;
}
export function homeMemberActivity(member, reviews, t, now = new Date()) {
  const reason = homeMemberReason(member);
  if (reason) return t(`home.reviewerReason.${reason}`, { count: member.sharedRatingCount ?? 0 });
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  const count = reviews.filter((item) => {
    const value = item.review?.createdAt;
    if (!value) return false;
    const normalized = value.trim().replace(/\./g, '-').replace(/-+$/, '');
    const date = new Date(normalized.includes('T') ? normalized : `${normalized}T00:00:00`);
    if (Number.isNaN(date.getTime())) return false;
    const age = Math.floor(
      (today - new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()) / 86400000,
    );
    return age >= 0 && age <= 7;
  }).length;
  return count > 0
    ? t('home.reviewerReason.recentReviews', { count })
    : reviews.length > 0
      ? t('home.reviewerReason.reviewCount', { count: reviews.length })
      : t('home.reviewerReason.newReview');
}
export function homeMemberCandidates({
  recommendations = [],
  reviews = [],
  following = [],
  userId,
  recommendationsPending = false,
  followingPending = false,
}) {
  // Server recommendation order/reasons are authoritative, including during
  // unrelated following reads. Empty success still uses recent reviewers.
  if (recommendations.length) return recommendations.slice(0, 12);
  if (userId && (recommendationsPending || followingPending)) return [];
  const follows = new Set(following.map((item) => item.id));
  const used = new Set();
  return reviews
    .filter((item) => {
      if (item.userId === userId || (userId && follows.has(item.userId)) || used.has(item.userId))
        return false;
      used.add(item.userId);
      return true;
    })
    .slice(0, 12)
    .map((item) => ({
      id: item.userId,
      nickname: item.userNickname,
      profileImageUrl: item.userProfileImageUrl,
      profileMark: item.userProfileMark,
    }));
}
